import { gql } from '@apollo/client'
import type { UseListProps, UseListResult } from '../useList/index'
import { useList } from '../useList/index'
import type { File } from '@ztechapps/common.contract'
import { StorageType } from '../useListAction/types'
import { useUserTimeZone } from '../useUser/useUserTimeZone'
import { useMemo } from 'react'
import merge from 'lodash/merge'

const defaultQuery = gql`
  query allFile($filter: JSON!, $options: JSON) {
    allFile(filter: $filter, options: $options) {
      _id
      name
      description
      size
      tags
      uri
      directoryTree
      updatedAt
      createdAt
      key
      mimetype
    }
    allFileMeta(filter: $filter) {
      count
    }
  }
`

export const useFileList = (props?: Partial<UseListProps>): UseListResult<File> => {
  const timeZone = useUserTimeZone()
  const defaultProps: UseListProps = {
    query: defaultQuery,
    sort: { createdAt: -1 },
    limit: 100,
    listActionOptions: {
      storageKey: 'fileFilterCategory',
      storageType: StorageType.localStorage,
      timeZone,
    },
  }

  const mergeUseListProps = useMemo(() => {
    //we cannot merge directly the query because lodash will do the infinite loop
    //so we remove it first and assign it later it later

    const { query: defaultQuery, ...restDefaultProps } = defaultProps
    const { query: propsQuery, ...restProps } = props ?? {}

    let finalProps = merge({}, restDefaultProps, restProps) as UseListProps
    finalProps = {
      ...finalProps,
      query: propsQuery ?? defaultQuery,
    }

    return finalProps
  }, [defaultProps, props])

  return useList<File>(mergeUseListProps)
}
